module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part2vs-14351d52.png";